/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { fragment } from 'ember-data-model-fragments/attributes';
import Fragment from 'ember-data-model-fragments/fragment';
import type SearchBarStyle from '../styles/search-bar';

export default class SearchBar extends Fragment {
  @fragment('customization-options/styles/search-bar') declare style: SearchBarStyle;
}
